<template>
    <div>
        <div class="container has-text-white">
           <H1 class="has-text-white is-size-3 top20">FORGOT PASSWORD</H1>
            <div class="limitWidth">
                <hr/>
            </div>
            <div class="limitWidth" v-show="showEnterEmail">
                <div>Please enter the email address you use to log in:</div>
                <form name="form1" v-on:submit.prevent="doForgot" data-vv-scope="form1">
                    <div class="field" :class="{formError: errors.first('form1.email') }">
                        <input type="text" class="input is-warning" name="email" v-validate="'required|email'" v-model="form1.email" />
                        <p class="help is-danger" >
                            {{ errors.first('form1.email') }}
                        </p>
                    </div>
                    <button id="submit1" class="button top10 is-coolGreen" type="submit">SUBMIT</button>
                </form>
            </div>

            <div class="limitWidth" v-show="showEnterPass">
               <div class="bottom10">A verification code was sent to <span class="has-text-weight-bold">{{form1.email}}</span>. Please enter it and provide the new password you would like to use.</div>
               <form name="form2" v-on:submit.prevent="doCode" data-vv-scope="form2">
                    <div class="field" :class="{formError: errors.first('form2.code') }">
                        Code:
                        <input type="text" class="input is-warning" name="code"  v-validate="'required'" v-model="form2.code"/>
                        <p class="help is-danger" >
                            {{ errors.first('form2.code') }}
                        </p>
                    </div>
                    <div class="field" :class="{formError: errors.first('form2.Pass') }" >
                        New Password:
                        <input class="input is-warning" type="password" name="Pass" v-validate="{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}" v-model="form2.pass"/>
                        <p class="help is-danger" >
                            {{ errors.first('form2.Pass') }}
                        </p>
                        <span class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter and at least one uppercase letter)</span>
                    </div>
                    <div class="field" :class="{formError: errors.first('form2.pass2') }">
                        Confirm Password:
                        <input class="input is-warning" type="password" name="pass2" v-validate="{required:true, is: form2.pass}" />
                        <p class="help is-danger" >
                            {{ errors.first('form2.pass2') }}
                        </p>
                    </div>
                    <button id="submit2" class="button top10 is-coolGreen" type="submit">SUBMIT</button>
                </form>
            </div>

            <div class="limitWidth" v-if="showDone">
                <div>Your password was successfullly changed!</div>
                <button class="button top10 is-coolGreen" @click="openLogin">LOGIN</button>
            </div>

            <div class="limitWidth" v-if="showError">
                <div>There was an error changing your password. Please try again.</div>
            </div>
        </div>
    </div>
</template>

<script>

var AmazonCognitoIdentity = require('amazon-cognito-identity-js')

export default {
  components: {
   
  },
  data: function () {
    var form1 = {email: ''}
    var form2 = {code: '', pass: '', pass2: ''}
    return {
      form1,
      form2,
      showEnterEmail: true,
      showEnterPass: false,
      showDone: false,
      showError: false,
      code: '',
      pass: '',
      pass2: ''
    }
  },
  mounted: function(){
      if(this.$root.app.isAuth){
      this.$router.push('/')
      this.$root.app.showModalOK({message: 'You are already signed in.'})
    }
  },

  methods: {
    doForgot: function () {
      var self = this
      this.$validator.validateAll('form1').then(res => {
        if (res) {
          sendForgot()
        } else {
          self.$root.app.showModalOK({message: 'Please provide a valid email.'})
        }
      })

      function sendForgot () {
        az.addRemSpinner(true, 'id', 'submit1');
        self.$root.app.azCognito.sendForgotPasswordCode(self.form1.email, sendForgotCallback)

        function sendForgotCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'submit1');
          if (result == 'success') {
            self.showEnterEmail = false
            self.showEnterPass = true
          } else if (result == 'error') {
            if (obj.code == 'UserNotFoundException') {
              self.$root.app.showModalOK({message: 'The email provided could not be found.'})
            } else if (obj.code == 'LimitExceededException') {
              self.$root.app.showModalOK({message: 'The retreive password attemps limit has been reached. Please try again later'})
            } else if(obj.message == 'Cannot reset password for the user as there is no registered/verified email or phone_number'){
              self.$root.app.showModalOK({message: 'You must verify your email from the link we sent you before resetting your password.'})
            }
          }
        }
      }
    },
    doCode: function () {
      var self = this
      this.$validator.validateAll('form2').then(res => {
        if (res) {
          sendChange()
        } else {
          self.$root.app.showModalOK({message: 'Please correct the errors on the form'})
        }
      })

      function sendChange () {
        az.addRemSpinner(true, 'id', 'submit2');
        self.$root.app.azCognito.doChangePassword(self.form1.email, self.form2.code, self.form2.pass, doChangePwdCallback)

        function doChangePwdCallback (result, err) {
          az.addRemSpinner(false, 'id', 'submit2');
          if (result == 'success') {
            self.showEnterPass = false
            self.showDone = true
            window.scrollTo(0, 0)
          } else if (result == 'error') {
            window.scrollTo(0, 0)
            if (err.code == 'CodeMismatchException' || err.code == 'ExpiredCodeException') {
              self.$root.app.showModalOK({message: 'The code you provided is invalid.'})
            } else {
              self.showEnterPass = false
              self.showError = true
            }
          }
        }
      }
    },
    openLogin: function () {
      this.$router.push('/')
      this.$root.app.showModalLogin({message: ''})
    }
  }
}
</script>
